module.exports = __webpack_public_path__ + "components/page-footer/static/weather-forecast__logo--white-6a052c15fdac1e6118418e3bdd24e95f.png";